module.exports = __webpack_public_path__ + "img/1-lugar.fdf28043.svg";